import type { ClickActionsMode } from "metabase/visualizations/types";
import type Question from "metabase-lib/v1/Question";

import { Mode } from "../Mode";
import { ArchivedMode } from "../modes/ArchivedMode";
import { DefaultMode } from "../modes/DefaultMode";
import { ListMode } from "../modes/ListMode";
import type { QueryClickActionsMode } from "../types";

export function getQueryMode(question: Question): QueryClickActionsMode {
  if (question.isArchived()) {
    return ArchivedMode;
  }
  return question.display() === "list" ? ListMode : DefaultMode;
}

export const defaultClickActionMode: ClickActionsMode = new Mode(getQueryMode);
